import React from "react";
import clockIcon from "../../../assets/svg/clock-1.svg";
import { calculateTotalShiftLength, getNameProfile, getShiftLength } from "Utils/utils";
import {
  getAdvanceShiftLengthDisplay,
  getAdvanceShiftWindowMinutes,
} from "./components/advanceModeValidation";
import AvatarGroup from "components/common/Avatar/AvatarGroup";
import ToolTipForRostering from "../Calendar/CalendarRow/Popovers/TooltipPopover";
import ShiftLocationSelector from "components/common/ShiftLocationSelector";
import moment from "moment";

const WorkerShiftDetail = (props) => {
  const {
    userItem,
    shiftDetail,
    isGroupShift,
    setIsSelectLocationOpen,
    selectedShift,
    isUserGracePeriodOver,
    onClearLocation,
    onUseParticipantLocation,
    isLocationManuallySet = false,
    hasParticipant = false,
    isAdvanceMode = false,
  } = props;
  const arrayData = userItem && Array.isArray(userItem) ? userItem : [userItem];

  const shiftStartTime =
    shiftDetail?.start_time || shiftDetail?.worker_start_time;
  const shiftEndTime = shiftDetail?.end_time || shiftDetail?.worker_end_time;

  const handleImageError = (e, fname, lname) => {
    return (e.target.src = getNameProfile(fname, lname, "0D8ABC"));
  };

  const getShiftLengthLabel = () => {
    if (isAdvanceMode) {
      return getAdvanceShiftLengthDisplay(shiftStartTime, shiftEndTime);
    }

    const basicAdvanceLabel = getAdvanceShiftLengthDisplay(
      shiftStartTime,
      shiftEndTime
    );
    if (basicAdvanceLabel) return basicAdvanceLabel;

    if (
      selectedShift !== null &&
      getTimeChanged()
    ) {
      return calculateTotalShiftLength(
        selectedShift?.start_time || selectedShift?.worker_start_time,
        selectedShift?.end_time || selectedShift?.worker_end_time
      );
    }

    return getShiftLength(shiftStartTime, shiftEndTime);
  };

  const hasValidShiftLength = () => {
    if (isAdvanceMode) {
      return Boolean(getAdvanceShiftLengthDisplay(shiftStartTime, shiftEndTime));
    }

    const windowMinutes = getAdvanceShiftWindowMinutes(shiftStartTime, shiftEndTime);
    if (windowMinutes != null) return true;

    return (
      ((shiftStartTime && shiftEndTime) ||
        (!shiftStartTime &&
          !shiftDetail?.worker_start_time &&
          !shiftEndTime &&
          !shiftDetail?.worker_end_time)) &&
      getShiftLength(shiftStartTime, shiftEndTime, false, true) === true
    );
  };

  const totalShiftLength = () => {
    if (isAdvanceMode) {
      const minutes = getAdvanceShiftWindowMinutes(shiftStartTime, shiftEndTime);
      if (minutes == null) return 0;
      return (minutes / 60).toFixed(2);
    }

    const windowMinutes = getAdvanceShiftWindowMinutes(shiftStartTime, shiftEndTime);
    if (windowMinutes != null) return (windowMinutes / 60).toFixed(2);

    const shiftLength = getShiftLength(shiftStartTime, shiftEndTime);

    const [hours, mins] = shiftLength
      .split(":")
      .map((time) => parseInt(time.replace(/[a-zA-Z]/g, ""), 10));

    const totalHours = hours + mins / 60;
    return totalHours.toFixed(2);
  };
  const handleSelectLocation = () => {
    setIsSelectLocationOpen(true);
  };

  const handleClearLocation = () => {
    if (onClearLocation) {
      onClearLocation();
    }
  };

  const getTimeChanged = () => {
    const modifiedStartTime = selectedShift?.start_time ? moment(selectedShift?.start_time.split(" ")[1], "HH:mm") : moment();
    const modifiedEndTime = selectedShift?.end_time ? moment(selectedShift?.end_time.split(" ")[1], "HH:mm") : moment();
    if (modifiedStartTime.isSame(moment(shiftDetail?.start_time, "HH:mm"), "minute") && modifiedEndTime.isSame(moment(shiftDetail?.end_time, "HH:mm"), "minute")) {
      return true;
    }
    return false;
  };

  return (
    <>
      <div className="flex gap-4 items-center flex-shrink-0">
        {arrayData && arrayData?.length > 0 && arrayData[0] !== null && (
          <AvatarGroup
            type="worker"
            arrayData={arrayData || []}
            cssClass="mt-0"
            maxLength={10}
            isForRostering
            isGroupShift={isGroupShift}
          />
        )}
      </div>
      <div className='flex items-center transition cursor-pointer ml-auto min-w-0 flex-1 justify-end gap-4'>
        {/* Location Selector + Shift Length */}
        <div className='flex gap-4 items-center min-w-0'>
          <ShiftLocationSelector
            locationData={shiftDetail?.shift_location}
            onSelectLocation={handleSelectLocation}
            onClearLocation={handleClearLocation}
            onUseParticipantLocation={onUseParticipantLocation}
            isManuallySet={isLocationManuallySet}
            hasParticipant={hasParticipant}
            buttonLabel="Select Shift Location"
          />
          {/* <div className="flex gap-4">
          <img src={dollarIcon} alt="user" width="50" height="50" />
          <div>
            <h6 className="text-gray-700 text-base font-semibold mb-0">
              {`$${userItem.hourly_rate ?? 0}`}
            </h6>
            <label className="text-gray-500 text-sm font-normal mb-0">
              Weekly Cost
            </label>
          </div>
        </div> */}

        {!isAdvanceMode && selectedShift !== null && getTimeChanged() ? (
            // Display this block if the conditions are met
            <div className="flex gap-1">
              <img src={clockIcon} alt="user" width="50" height="50" />
              {calculateTotalShiftLength(  selectedShift?.start_time || selectedShift?.worker_start_time,
                    selectedShift?.end_time || selectedShift?.worker_end_time,true) > 10 ? (
                <ToolTipForRostering
                  cssClass={"py-1 px-1 rounded text-white z-[9]"}
                  data="Over 10 hours in a shift will result in Overtime"
                />
              ) : calculateTotalShiftLength(  selectedShift?.start_time || selectedShift?.worker_start_time,
                    selectedShift?.end_time || selectedShift?.worker_end_time,true) > 10 ? (
                <ToolTipForRostering
                  cssClass={"py-1 px-1 rounded text-white z-[9]"}
                  data="Over 10 hours in a shift will result in Overtime"
                />
              ) : null}
              <div>

                <h6 className="text-gray-700 text-base font-semibold mb-0">

                  {

                 calculateTotalShiftLength(  selectedShift?.start_time || selectedShift?.worker_start_time,
                    selectedShift?.end_time || selectedShift?.worker_end_time)
                  }

                </h6>

                <label className="text-gray-500 text-sm font-normal mb-0">
                  Shift Length
                </label>
              </div>
            </div>
          ) :
          hasValidShiftLength() ? (
            <div className='flex gap-1 items-center'>
              <img src={clockIcon} alt='user' width='50' height='50' />
              {totalShiftLength() > 10 ? (
                <ToolTipForRostering
                  cssClass={"py-1 px-1 rounded text-white z-[9]"}
                  data='Over 10 hours in a shift will result in Overtime'
                />
              ) : totalShiftLength() > 10 ? (
                <ToolTipForRostering
                  cssClass={"py-1 px-1 rounded text-white z-[9]"}
                  data='Over 10 hours in a shift will result in Overtime'
                />
              ) : null}
              <div>

                <h6 className="text-gray-700 text-base font-semibold mb-0">
                  {getShiftLengthLabel()}
                </h6>
                <label className='text-gray-500 text-sm font-normal mb-0'>
                  Shift Length
                </label>
              </div>
            </div>
          ) : (
            <div className='flex gap-4 items-center'>
              <img src={clockIcon} alt='user' width='50' height='50' />
              <div>
                <h6 className='text-gray-700 text-base font-semibold mb-0'>
                  NA
                </h6>
                <label className='text-gray-500 text-sm font-normal mb-0'>
                  Shift Length
                </label>
              </div>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default WorkerShiftDetail;
